module.exports = __webpack_public_path__ + "static/afnan-cc01a145cc6ef312b9e7edf1df1026aa.png";